<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <logo />
        <v-card class="elevation-12">
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
            @submit.prevent="valid && signIn()"
          >
            <v-toolbar dark color="primary">
              <v-toolbar-title>Login</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-text-field
                v-model="email"
                prepend-icon="person"
                name="email"
                label="Email"
                type="email"
                :rules="[v => !!v || 'Enter your email']"
                required
              ></v-text-field>
              <v-text-field
                v-model="password"
                prepend-icon="lock"
                name="password"
                label="Password"
                type="password"
                :rules="[v => !!v || 'Enter your password']"
                required
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                type="submit"
                :disabled="!valid"
                color="error"
                :loading="loading"
              >
                Login
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Logo from '@/components/Logo.vue';
import { auth } from '../firebaseConfig.js';

export default {
  name: 'Login',
  components: {
    Logo
  },
  data() {
    return {
      email: '',
      password: '',
      valid: true,
      loading: false
    };
  },
  methods: {
    async getUserInfo(id) {
      await this.$store.dispatch('getUserInfo', id);
      this.loading = false;
      this.$router.replace('dashboard');
    },
    signIn() {
      this.loading = true;
      if (this.$refs.form.validate()) {
        auth.signInWithEmailAndPassword(this.email, this.password).then(
          res => {
            this.$store.commit('setCurrentUser', res.user);
            this.getUserInfo(res.user.uid);
          },
          err => {
            alert('Error: ' + err.message);
            this.loading = false;
          }
        );
      }
    }
  }
};
</script>

<style lang="scss">
input:-webkit-autofill {
  background-color: rgba(255, 255, 255, 0.1) !important;
}
</style>
